import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-aberburkinafaso',
  templateUrl: './aberburkinafaso.component.html',
  styleUrls: ['./aberburkinafaso.component.scss']
})
export class AberBurkinaFasoComponent {

  constructor() { }

}
